import clsx from 'clsx'
import type { KeyboardEvent, MouseEvent, PropsWithChildren } from 'react'

import type { PropsWithClassName } from '@fv/client-types'

type Props = {
  st?: boolean // static is reserved
  fixedWidthIcon?: boolean
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
  role?: string
  tabIndex?: number
  ariaExpanded?: boolean
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void
}
export const PillHeader = ({
  children,
  className,
  st,
  fixedWidthIcon,
  onClick,
  role,
  tabIndex,
  ariaExpanded,
  onKeyDown,
}: PropsWithClassName<PropsWithChildren<Props>>) => (
  <div
    className={clsx(
      { 'absolute -left-2 -top-5': !st },
      'rounded-full px-4 py-1 inline-flex gap-x-2 border-2 items-center',
      !fixedWidthIcon && 'fa-width-auto',
      className,
    )}
    onClick={onClick}
    role={role}
    tabIndex={tabIndex}
    aria-expanded={ariaExpanded}
    onKeyDown={onKeyDown}
  >
    {children}
  </div>
)
